module.exports = __webpack_public_path__ + "img/18.7ad708f7.jpg";